export const COUNTRY_CODE_MAP = [
	{ value: 'US', icon : 'us', icon2 : 'fi fi-us' , cn: '美国' , currency : 'USD' , symbol : '$' ,department : 'Amazon.com'},
	{ value: 'UK', icon : 'gb', icon2 : 'fi fi-gb' , cn: '英国', currency : 'GBP' ,symbol : '£',department : 'Amazon.co.uk'},
	{ value: 'DE', icon : 'de', icon2 : 'fi fi-de' , cn: '德国' , currency : 'DEM',symbol : '€',department : 'Amazon.de'},
	{ value: 'FR', icon : 'fr', icon2 : 'fi fi-fr' , cn: '法国' , currency : 'FRF',symbol : '€',department : 'Amazon.fr'},
	{ value: 'JP', icon : 'jp', icon2 : 'fi fi-jp' , cn: '日本' , currency : 'JPY',symbol : 'JPY¥',department : 'Amazon.jp'},
	{ value: 'IT', icon : 'it', icon2 : 'fi fi-it' , cn: '意大利', currency : 'ITL' ,symbol : '€',department : 'Amazon.it'},
	{ value: 'ES', icon : 'es', icon2 : 'fi fi-es' , cn: '西班牙' , currency : 'ESP',symbol : '€',department : 'Amazon.es'},
	{ value: 'MX', icon : 'mx', icon2 : 'fi fi-mx' , cn: '墨西哥' , currency : 'MXP',symbol : 'MXN$',department : 'Amazon.com.mx'},
	{ value: 'CA', icon : 'ca', icon2 : 'fi fi-ca'  ,cn: '加拿大' , currency : 'CAD',symbol : 'C$',department : 'Amazon.ca'},
	{ value: 'AU', icon : 'au', icon2 : 'fi fi-au'  ,cn: '澳大利亚' , currency : 'au',symbol : 'AUD$',department : 'amazon.com.au'},
]

export const COUNTRY_CODE_MAP2 = [
	{ value: 'US', icon : 'us', cn: '美国' , currency : 'USD' , symbol : '$' ,department : 'Amazon.com'},
	{ value: 'UK', icon : 'gb', cn: '英国', currency : 'GBP' ,symbol : '£',department : 'Amazon.co.uk'},
	{ value: 'DE', icon : 'de', cn: '德国' , currency : 'DEM',symbol : '€',department : 'Amazon.de'},
	{ value: 'FR', icon : 'fr', cn: '法国' , currency : 'FRF',symbol : '€',department : 'Amazon.fr'},
	{ value: 'JP', icon : 'jp', cn: '日本' , currency : 'JPY',symbol : 'JPY¥',department : 'Amazon.jp'},
]


export function getSymbolByCurrency (currency){
	if (!currency) return
	return COUNTRY_CODE_MAP.find(i => i.currency.toLowerCase()  == currency.toLowerCase()).symbol
}

export function getSymbolByValue (value){
	return COUNTRY_CODE_MAP.find(i => i.value == value).symbol
}

export function getCountryByValue (value="US"){
	return COUNTRY_CODE_MAP.find(i => i.value === value)
}


export function getCountryObjByCity (city){
	return COUNTRY_CODE_MAP.find(i => i.value.toLowerCase() === city.toLowerCase())
}